import { mockProcessStep as emptyMockProcessStep } from "../mocks/mockProcessStep";
import { mockQuoteRequest } from "../mocks/mockQuoteRequest";
import { mockQuoteRequestLine } from "../mocks/mockQuoteRequestLine";
import { ComputeQuoteRequestPriceParams } from "./computeQuoteRequestPrice";

const emptyMockQrl = {
  ...mockQuoteRequestLine,
  productLines: [],
  batchId: null as string | null,
  assemblyParentId: null as string | null,
};

// -----------------------------------------------------------------------------
// Simple sheet part
// Batch with quantity 1 and 10
// -----------------------------------------------------------------------------
const simpleSheetBatch1 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T10:44:34.489Z",
  id: "d1f6a0ce-84b5-4661-ba45-d506ff6b8761",
  quantity: 10,
  batchId: "batch-simple-sheet",
  partId: "2c3c4594-bb7b-4737-a147-da815c9513c0",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T10:44:34.489Z",
      updatedAt: "2025-12-10T10:44:37.487Z",
      id: "cdd067ee-9255-4cd1-b7e7-3a174d9d4d69",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 30,
      price: 0,
      pricingMode: "RAW",
      volume: 60000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 36,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "5ee9c891-358b-420f-9c33-77b4b15e9abd",
    },
  },
};
const simpleSheetBatch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T10:43:27.754Z",
  id: "61f27ec6-a2a8-4152-b71f-c5395b37fc92",
  quantity: 1,
  productsMarginRatio: 100,
  addedValueMarginRatio: 10,
  batchId: "batch-simple-sheet",
  partId: "2c3c4594-bb7b-4737-a147-da815c9513c0",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-11T15:58:40.589Z",
          updatedAt: "2025-12-11T15:58:40.589Z",
          id: "8bddfcb5-28cc-4479-8344-8bcaa1866b98",
          isQuantityPerPart: true,
          quantity: 1,
          name: "Boite",
          price: 0,
          fixedPrice: 10000,
          productId: "00d50538-85d2-4fa3-9f52-173924332d02",
          quoteRequestLineId: null,
          processStepId: "60ec869b-27b6-4c4c-8378-52716b74321c",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-11T15:58:40.589Z",
            updatedAt: "2025-12-11T15:58:40.589Z",
            id: "00d50538-85d2-4fa3-9f52-173924332d02",
            name: "Boite",
            price: 0,
            fixedPrice: 10000,
            companyId: null,
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T10:43:27.754Z",
      updatedAt: "2025-12-11T09:25:47.625Z",
      id: "ae7e05de-134d-45eb-8b97-4c2ad3073224",
      length: 2000,
      tubeThickness: 0,
      width: 1000,
      height: 30,
      price: 0,
      pricingMode: "RAW",
      volume: 60000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 36,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "abae94e5-ddc3-44d1-8d61-8890477b78e7",
    },
  },
};

// -----------------------------------------------------------------------------
// Flat sheet part
// Batch with quantity 1, 100, 1000
// -----------------------------------------------------------------------------
const flatSheetBatch1 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.424Z",
  id: "b7c9289b-ec79-4e6c-9fce-885a920eb056",
  quantity: 1,
  addedValueMarginRatio: 50,
  batchId: "batch-flat-sheet",
  partId: "c464d7d4-a470-477c-aca1-a41ce7e6f759",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "MILLING",
      description: "FRAISAGE (210200)",
      otherMachineTime: 3979.06134119836,
      machinePreparationTime: 381.0018825531006,
      machineHourlyPrice: 4800,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.424Z",
      updatedAt: "2025-12-10T13:54:00.131Z",
      id: "97988791-e18c-4061-bddc-f422582dbb8d",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 546,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "a0074d7a-ba81-43b4-aa3a-e632e882250b",
    },
  },
};
const flatSheetBatch100 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:41.007Z",
  id: "6919b042-4376-4683-9e3e-a188c2d15c65",
  quantity: 100,
  addedValueMarginRatio: 30,
  batchId: "batch-flat-sheet",
  partId: "c464d7d4-a470-477c-aca1-a41ce7e6f759",
  processSteps: [
    {
      createdAt: "2025-12-10T13:54:41.025Z",
      updatedAt: "2025-12-10T13:54:41.025Z",
      id: "c4eef109-b42e-4b45-add0-18b96b350c8e",
      mode: "TIME",
      quoteLineId: null,
      industrialProcess: "MILLING",
      index: 0,
      description: "FRAISAGE (210200)",
      type: null,
      margin: 0,
      toolingCost: null,
      otherMachineTime: 3979.06134119836,
      machinePreparationTime: 381.0018825531006,
      machineHourlyPrice: 4800,
      manTime: null,
      manHourlyPrice: 0,
      isFixedCostPerSeries: null,
      fixedCost: null,
      fixedCostPerSeries: null,
      materialLoadTimeMinutes: null,
      partLoadTimeMinutes: null,
      materialUnloadingTime: null,
      partsToPackQuantity: null,
      minimumOrderAmount: null,
      productsMarginRatio: null,
      packingHourlyPrice: null,
      partsToControlRatio: null,
      isMaterialLayoutPerPart: null,
      cycleTimeCost: null,
      machinePreparationTimeCost: null,
      materialLayoutId: null,
      predictionId: null,
      companyMachineId: null,
      quoteRequestLineId: "6919b042-4376-4683-9e3e-a188c2d15c65",
      quoteRequestId: null,
      companySettingsId: null,
      materialLayout: null,
      companyMachine: null,
      productLines: [],
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:41.007Z",
      updatedAt: "2025-12-10T13:54:49.345Z",
      id: "3709a4f3-a2a1-4527-ab4c-8897bd9a3895",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 546,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "b694b9b0-ce03-4dd3-95f0-feaf2113fc61",
    },
  },
};
const flatSheetBatch1000 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:44.839Z",
  id: "4d336cf5-0c17-411c-a100-cda967cfe638",
  quantity: 1000,
  batchId: "batch-flat-sheet",
  partId: "c464d7d4-a470-477c-aca1-a41ce7e6f759",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "MILLING",
      description: "FRAISAGE (210200)",
      otherMachineTime: 3979.06134119836,
      machinePreparationTime: 381.0018825531006,
      machineHourlyPrice: 4800,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:44.839Z",
      updatedAt: "2025-12-10T13:54:52.300Z",
      id: "fff16d5a-3424-474d-b760-6c69861704f8",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 2,
      maxPartsPerLayout: 546,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "a41cc8f7-54c5-49ff-90b4-4d6dd4ae17f2",
    },
  },
};

// -----------------------------------------------------------------------------
// Assembly default
// Batch with quantity 2, 10 and 50
// -----------------------------------------------------------------------------
// Batch 2
const assemblyParentBatch2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.419Z",
  id: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  quantity: 2,
  batchId: "batch-assembly-default",
  partId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
  processSteps: [],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.419Z",
      updatedAt: "2025-12-10T15:36:53.132Z",
      id: "6ee5e24a-11df-4bfc-915d-4db19e97d308",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 1,
      price: 0,
      pricingMode: "RAW",
      volume: 2000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 4,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "8fa6c866-005e-4402-ab40-5caff315debf",
    },
  },
};
const assemblyChild1Batch2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.447Z",
  id: "8d84597b-8452-4aec-8526-b16f6178c3e9",
  quantity: 2,
  partId: "7fb4e075-0a2f-4457-a9f4-4f2458e12a7d",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.447Z",
      updatedAt: "2025-12-10T15:36:53.131Z",
      id: "54265e70-3c2b-41f9-b9fb-25143406b1c2",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 9,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "68236636-22c2-4794-a043-34a91f636a28",
    },
  },
};
const assemblyChild2Batch2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.435Z",
  id: "85ca550a-2eaa-4df6-ba86-0658dc23ebed",
  quantity: 2,
  partId: "914db114-a456-415e-829f-62e41531560e",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  part: {
    createdAt: "2025-12-09T10:53:45.671Z",
    updatedAt: "2025-12-10T13:54:23.179Z",
    id: "914db114-a456-415e-829f-62e41531560e",
    name: "assemblage.sh2",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 5,
    width: 70,
    length: 70,
    tubeThickness: null,
    volume: 15664.44,
    area: 7438.71,
    boundingBoxX: 5,
    boundingBoxY: 70,
    boundingBoxZ: 70,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "SHEET",
    quantityInAssembly: 2,
    parentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    rootParentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.435Z",
      updatedAt: "2025-12-10T15:36:53.132Z",
      id: "b2720328-df0e-44e1-82c0-c04af158a113",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 338,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "3116c06f-ca44-4257-93eb-1e63fd062b76",
    },
  },
};
const assemblyChild3Batch2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.448Z",
  id: "334002ce-873b-451a-b3ab-ba728b76d749",
  quantity: 2,
  partId: "5f50bb1f-d684-4600-8a32-eaa85dcdd679",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.448Z",
      updatedAt: "2025-12-10T15:36:53.132Z",
      id: "151203a4-a1d6-4d93-a771-499f3882b2cd",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 1008,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "ab6b4c7f-089e-44f1-814d-39f8680c5b2c",
    },
  },
};
const assemblyChild4Batch2 = {
  ...emptyMockQrl,
  layout: null,
  createdAt: "2025-12-10T13:53:28.448Z",
  id: "e861cef4-93a6-44c5-8755-6cf64f8a259e",
  quantity: 2,
  partId: "8fe9f928-2aec-4ae8-ac22-e7b01475efba",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  part: {
    createdAt: "2025-12-09T10:53:51.640Z",
    updatedAt: "2025-12-10T13:54:23.179Z",
    id: "8fe9f928-2aec-4ae8-ac22-e7b01475efba",
    name: "assemblage.co7",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 5,
    width: 11,
    length: 13,
    tubeThickness: null,
    volume: 379.57,
    area: 428.29,
    boundingBoxX: 5,
    boundingBoxY: 11,
    boundingBoxZ: 13,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "CONSUMABLE",
    quantityInAssembly: 2,
    parentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    rootParentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:53:28.448Z",
          updatedAt: "2025-12-10T13:53:28.448Z",
          id: "919df1dc-5df9-4819-b793-9bf813d17064",
          isQuantityPerPart: true,
          quantity: 2,
          name: "assemblage.co7",
          price: 0,
          fixedPrice: null,
          productId: "649536ae-1853-4c55-9d57-ade2d9bfa101",
          quoteRequestLineId: null,
          processStepId: "b7b13961-a995-43a5-85a9-10d116a2b324",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.448Z",
            updatedAt: "2025-12-10T13:53:28.448Z",
            id: "649536ae-1853-4c55-9d57-ade2d9bfa101",
            name: "assemblage.co7",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild5Batch2 = {
  ...emptyMockQrl,
  layout: null,
  createdAt: "2025-12-10T13:53:28.434Z",
  id: "923500c6-0719-49d5-b2dd-f7e67c5200ab",
  quantity: 2,
  partId: "10f0803a-6679-48e4-82c7-e106fd14e1bd",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  part: {
    createdAt: "2025-12-09T10:53:50.184Z",
    updatedAt: "2025-12-10T13:54:23.179Z",
    id: "10f0803a-6679-48e4-82c7-e106fd14e1bd",
    name: "assemblage.co6",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 13,
    width: 24,
    length: 28,
    tubeThickness: null,
    volume: 4035.65,
    area: 2236.48,
    boundingBoxX: 13,
    boundingBoxY: 24,
    boundingBoxZ: 28,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "CONSUMABLE",
    quantityInAssembly: 1,
    parentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    rootParentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:53:28.434Z",
          updatedAt: "2025-12-10T13:53:28.434Z",
          id: "070ce3d8-faf9-4337-a542-54974849e93d",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co6",
          price: 0,
          fixedPrice: null,
          productId: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
          quoteRequestLineId: null,
          processStepId: "674e290a-62c1-449d-9d1f-b175e010ffb5",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
            name: "assemblage.co6",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild6Batch2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.434Z",
  id: "4d1a3d56-c942-4f99-a30c-0d7f45eeada5",
  quantity: 2,
  partId: "51ad3c7e-8703-416b-9a3a-52420d2ed340",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.434Z",
      updatedAt: "2025-12-10T15:36:53.130Z",
      id: "345b3bbf-6ebd-4d86-889c-952eb2dbab56",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 76,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "59c96fea-21ce-491f-afff-9f41387168ce",
    },
  },
};
const assemblyChild7Batch2 = {
  ...emptyMockQrl,
  layout: null,
  createdAt: "2025-12-10T13:53:28.434Z",
  id: "eec3af10-7f78-4f54-8441-3111b2f4d233",
  quantity: 2,
  partId: "12ae5e14-5ad8-40c0-80f7-aac067f48efe",
  assemblyParentId: "b45e8bd6-6218-4e10-b967-e55bf07e29f4",
  part: {
    createdAt: "2025-12-09T10:53:47.101Z",
    updatedAt: "2025-12-10T13:54:23.179Z",
    id: "12ae5e14-5ad8-40c0-80f7-aac067f48efe",
    name: "assemblage.co4",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 30,
    width: 30,
    length: 50,
    tubeThickness: null,
    volume: 10799.22,
    area: 9071.35,
    boundingBoxX: 30,
    boundingBoxY: 30,
    boundingBoxZ: 50,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "CONSUMABLE",
    quantityInAssembly: 1,
    parentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    rootParentId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:53:28.434Z",
          updatedAt: "2025-12-10T13:53:28.434Z",
          id: "8dff7cea-ec91-4dbc-aa1a-33e01f886cb3",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co4",
          price: 0,
          fixedPrice: null,
          productId: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
          quoteRequestLineId: null,
          processStepId: "9c2fe520-8b31-4941-a4bf-5a86195a56ba",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
            name: "assemblage.co4",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};

// Batch 10
const assemblyParentBatch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.364Z",
  id: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  quantity: 10,
  batchId: "batch-assembly-default",
  partId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
  processSteps: [],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:20.364Z",
      updatedAt: "2025-12-10T13:54:30.820Z",
      id: "5859d89c-a729-41bf-8586-c2d78e63e5fb",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 1,
      price: 0,
      pricingMode: "RAW",
      volume: 2000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 3,
      maxPartsPerLayout: 4,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "2a5ff558-3625-47b4-8acf-6573bfae7dee",
    },
  },
};
const assemblyChild1Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.425Z",
  id: "818cdfb3-0f8f-4810-868a-8a80d75f5dc2",
  quantity: 10,
  partId: "7fb4e075-0a2f-4457-a9f4-4f2458e12a7d",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:20.425Z",
      updatedAt: "2025-12-10T13:54:30.819Z",
      id: "24934a14-ad9b-4780-9585-1463b4f3ebd9",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 2,
      maxPartsPerLayout: 9,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "704471f5-5176-48b8-b222-fbaac2a0ec62",
    },
  },
};
const assemblyChild2Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.423Z",
  id: "92a6f37d-2294-4d72-bab6-259a054e0e27",
  quantity: 10,
  partId: "8fe9f928-2aec-4ae8-ac22-e7b01475efba",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:20.456Z",
          updatedAt: "2025-12-10T13:54:20.456Z",
          id: "6bdaf356-2d91-4dce-8131-84b00b32bf02",
          isQuantityPerPart: true,
          quantity: 2,
          name: "assemblage.co7",
          price: 0,
          fixedPrice: null,
          productId: "649536ae-1853-4c55-9d57-ade2d9bfa101",
          quoteRequestLineId: null,
          processStepId: "eb3a554b-df0a-4eb0-8e90-14614afe2f68",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.448Z",
            updatedAt: "2025-12-10T13:53:28.448Z",
            id: "649536ae-1853-4c55-9d57-ade2d9bfa101",
            name: "assemblage.co7",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild3Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.426Z",
  id: "a730bbdb-9acf-483d-b191-3c1abe39804e",
  quantity: 10,
  partId: "51ad3c7e-8703-416b-9a3a-52420d2ed340",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:20.426Z",
      updatedAt: "2025-12-10T13:54:30.819Z",
      id: "51d77eb6-5da8-45ce-9fc7-efd5daf4cf64",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 76,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "98d0d4e5-3d34-48b3-957b-b0523de22ca5",
    },
  },
};
const assemblyChild4Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.418Z",
  id: "33a73098-5332-40b5-9f3e-b04349bb48b9",
  quantity: 10,
  partId: "10f0803a-6679-48e4-82c7-e106fd14e1bd",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:20.451Z",
          updatedAt: "2025-12-10T13:54:20.451Z",
          id: "fdc6e633-10ef-41cc-99af-f979e3ba215a",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co6",
          price: 0,
          fixedPrice: null,
          productId: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
          quoteRequestLineId: null,
          processStepId: "7bedfa4d-fbca-48f4-be28-1c5917f2114d",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
            name: "assemblage.co6",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild5Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.423Z",
  id: "20e496cc-f221-4347-9cc1-ab593f724a6c",
  quantity: 10,
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:20.453Z",
          updatedAt: "2025-12-10T13:54:20.453Z",
          id: "0920c568-36ed-4a5a-ab38-35d60f488d25",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co4",
          price: 0,
          fixedPrice: null,
          productId: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
          quoteRequestLineId: null,
          processStepId: "17992aaf-b52e-4dff-9ef6-6cb5bf8dfd76",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
            name: "assemblage.co4",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild6Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.425Z",
  id: "672f307e-6b86-4c03-a16b-83342af65917",
  quantity: 10,
  partId: "5f50bb1f-d684-4600-8a32-eaa85dcdd679",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:20.425Z",
      updatedAt: "2025-12-10T13:54:30.818Z",
      id: "bb824996-3429-4f8c-94fd-21dff93ec312",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 1008,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "ad470c38-3a1f-4c6b-b1d0-2a67b79ecee9",
    },
  },
};
const assemblyChild7Batch10 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:20.427Z",
  id: "bfb89eab-6cd9-4128-ac60-68c13d32ccc6",
  quantity: 10,
  partId: "914db114-a456-415e-829f-62e41531560e",
  assemblyParentId: "9622e4ef-ca4d-41c4-8f3e-b1af5992a851",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:20.427Z",
      updatedAt: "2025-12-10T13:54:30.820Z",
      id: "54e5401d-02c3-4d54-a404-1e75c4220407",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 338,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "fd9bb6eb-7d52-48af-bd3c-f38dc0271e67",
    },
  },
};

// Batch 50
const assemblyParentBatch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.155Z",
  id: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  quantity: 50,
  batchId: "batch-assembly-default",
  partId: "b43484f9-7ded-442a-b1c5-a9307202a76f",
  processSteps: [],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:23.155Z",
      updatedAt: "2025-12-10T13:54:33.459Z",
      id: "99696e0b-d969-46d2-b906-6a5a24f79f0f",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 1,
      price: 0,
      pricingMode: "RAW",
      volume: 2000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 13,
      maxPartsPerLayout: 4,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "01092bc2-ce2b-42a8-b940-60ba1aab39b2",
    },
  },
};
const assemblyChild1Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.197Z",
  id: "d6b36cc8-6763-4023-83db-02ecb6e9d621",
  quantity: 50,
  partId: "7fb4e075-0a2f-4457-a9f4-4f2458e12a7d",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:23.197Z",
      updatedAt: "2025-12-10T13:54:33.457Z",
      id: "2b2ab91d-f07b-4698-87b8-e2564bfef177",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 6,
      maxPartsPerLayout: 9,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "b51969e3-9568-4602-a09e-1a2eb004dd38",
    },
  },
};
const assemblyChild2Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.198Z",
  id: "fd2dccee-fb30-4dc5-abdb-51b27bc97fd2",
  quantity: 50,
  partId: "10f0803a-6679-48e4-82c7-e106fd14e1bd",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:23.219Z",
          updatedAt: "2025-12-10T13:54:23.219Z",
          id: "a8cf52ac-74f5-4ebc-8b89-a0d0530a5d01",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co6",
          price: 0,
          fixedPrice: null,
          productId: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
          quoteRequestLineId: null,
          processStepId: "9e9da525-373b-4e73-a6ca-65f2fe301302",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "91ee470c-8dae-45ee-9f99-a6b4b4befb3d",
            name: "assemblage.co6",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild3Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.195Z",
  id: "3a428a66-612b-4ece-8d79-84268e9ffcd5",
  quantity: 50,
  partId: "51ad3c7e-8703-416b-9a3a-52420d2ed340",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:23.195Z",
      updatedAt: "2025-12-10T13:54:33.458Z",
      id: "5ffc5a9d-2b0b-4d91-a68d-0bf26a58ea7e",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 76,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "21f2135a-2642-4955-aaf5-001a566217a2",
    },
  },
};
const assemblyChild4Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.194Z",
  id: "66602292-336c-4e48-9e26-8f285b472f92",
  quantity: 50,
  partId: "12ae5e14-5ad8-40c0-80f7-aac067f48efe",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:23.217Z",
          updatedAt: "2025-12-10T13:54:23.217Z",
          id: "1d21340f-debf-4a4b-9410-2bb18517de65",
          isQuantityPerPart: true,
          quantity: 1,
          name: "assemblage.co4",
          price: 0,
          fixedPrice: null,
          productId: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
          quoteRequestLineId: null,
          processStepId: "c4faecd7-6192-41dd-b87c-3c708a647b12",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.434Z",
            updatedAt: "2025-12-10T13:53:28.434Z",
            id: "e3623d98-cdd8-4175-9498-cbeb6fffb61f",
            name: "assemblage.co4",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild5Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.199Z",
  id: "1198ed39-945d-4da3-a768-b47d7ac4fce3",
  quantity: 50,
  partId: "8fe9f928-2aec-4ae8-ac22-e7b01475efba",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "PARAMETER",
      industrialProcess: "PRODUCTS",
      productLines: [
        {
          createdAt: "2025-12-10T13:54:23.220Z",
          updatedAt: "2025-12-10T13:54:23.220Z",
          id: "33c6298e-c3c4-4c63-9e4c-73089d6a8a3b",
          isQuantityPerPart: true,
          quantity: 2,
          name: "assemblage.co7",
          price: 0,
          fixedPrice: null,
          productId: "649536ae-1853-4c55-9d57-ade2d9bfa101",
          quoteRequestLineId: null,
          processStepId: "d4c55858-18f8-4fda-884a-c9bf4d53ef25",
          quoteRequestId: null,
          product: {
            createdAt: "2025-12-10T13:53:28.448Z",
            updatedAt: "2025-12-10T13:53:28.448Z",
            id: "649536ae-1853-4c55-9d57-ade2d9bfa101",
            name: "assemblage.co7",
            price: 0,
            fixedPrice: null,
            companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
            supplierId: null,
            type: "CONSUMABLE",
            companySettingsId: null,
          },
        },
      ],
    },
  ],
};
const assemblyChild6Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.198Z",
  id: "3843fffb-2d42-446e-81d1-1af02f27717c",
  quantity: 50,
  partId: "5f50bb1f-d684-4600-8a32-eaa85dcdd679",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:23.198Z",
      updatedAt: "2025-12-10T13:54:33.459Z",
      id: "65bed16d-e0a2-44cf-839d-b206d02df76d",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 1008,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "ef010a34-ce67-4665-849b-0bedbd3e0c77",
    },
  },
};
const assemblyChild7Batch50 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:54:23.195Z",
  id: "b6c1ccef-b961-432d-9c03-d8ac8b430389",
  quantity: 50,
  partId: "914db114-a456-415e-829f-62e41531560e",
  assemblyParentId: "89fe2a4c-b160-4d96-b4d4-8b083e4229c2",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:54:23.195Z",
      updatedAt: "2025-12-10T13:54:33.458Z",
      id: "af499c17-c997-4012-8601-b6e009ad4709",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 338,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "5ea29c3c-ddd5-4946-bb07-a59297698a31",
    },
  },
};

// -----------------------------------------------------------------------------
// Assembly sheet
// -----------------------------------------------------------------------------
const assemblySheetParent = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:33.019Z",
  id: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  quantity: 1,
  partId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
  processSteps: [],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:33.019Z",
      updatedAt: "2025-12-10T13:53:59.986Z",
      id: "ab1467c1-f9f8-4e23-80c6-672aa3aa3d6a",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 1,
      price: 0,
      pricingMode: "RAW",
      volume: null,
      volumetricPrice: null,
      density: 0,
      quantity: 1,
      maxPartsPerLayout: null,
      type: "OTHER",
      materialGrade: "PLASTIC",
      layoutId: "6eb3522a-6396-4bb1-a780-1bb7de4c29d3",
    },
  },
};
const assemblySheetChild1 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:39.067Z",
  id: "678fb8f3-cf8e-4519-bf7b-74182c2df253",
  quantity: 1,
  partId: "8032c383-76e8-4191-9e48-e8fc7695f523",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:39.067Z",
      updatedAt: "2025-12-10T13:54:00.900Z",
      id: "50de8b31-2e97-4ff7-b3af-56132ba0c526",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 2,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "0b81c8a3-c1ec-4213-816b-5684b58560bf",
    },
  },
};
const assemblySheetChild2 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:37.594Z",
  id: "4e3875c7-b406-44c7-a32d-db5730a87d8e",
  quantity: 1,
  partId: "88417986-b7df-4496-b9ad-445c9ad8b8b3",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "MILLING",
      description: "FRAISAGE (210200)",
      otherMachineTime: 7.692841581638817,
      machinePreparationTime: 147.1797180175781,
      machineHourlyPrice: 4800,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:37.594Z",
      updatedAt: "2025-12-10T13:54:00.816Z",
      id: "674b0be5-303f-493a-9022-8e5b7638e85f",
      length: 4395,
      tubeThickness: null,
      width: 460,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6065100,
      volumetricPrice: null,
      density: 1.2,
      quantity: 0,
      maxPartsPerLayout: 0,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "72e63f0c-4527-4fe3-b2b9-81f293098434",
    },
  },
};
const assemblySheetChild3 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:42.341Z",
  id: "c61e6f2d-0cc3-499f-a80e-d5c7e4940522",
  quoteRequestId: "ae072cde-a6ab-4915-acc2-f37c49e130a7",
  quantity: 1,
  partId: "6644d4c7-b688-4a06-a6d1-5e9daa63aba1",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:42.341Z",
      updatedAt: "2025-12-10T13:54:02.412Z",
      id: "adbb924d-c404-48ea-a95b-9f7b85b679f1",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 10,
      price: 0,
      pricingMode: "RAW",
      volume: 20000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 21,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "1e7713c1-f02d-4e98-8836-08a7654734e1",
    },
  },
};
const assemblySheetChild4 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:49.262Z",
  id: "4dd3917a-ed60-43f7-86ef-3c3d5ee5e96e",
  quantity: 1,
  partId: "9ed2a8d8-3ca4-4c53-afac-63091fb2cb56",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  part: {
    createdAt: "2025-12-10T13:53:49.224Z",
    updatedAt: "2025-12-10T13:53:59.986Z",
    id: "9ed2a8d8-3ca4-4c53-afac-63091fb2cb56",
    name: "assemblage-tollerie.sh11",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 2,
    width: 77,
    length: 77,
    tubeThickness: null,
    volume: 11815.08,
    area: 12413.91,
    boundingBoxX: 2,
    boundingBoxY: 77,
    boundingBoxZ: 77,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "SHEET",
    quantityInAssembly: 2,
    parentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    rootParentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:49.262Z",
      updatedAt: "2025-12-10T13:54:02.730Z",
      id: "aad8c4f7-07fa-4196-ac83-ab2b01776516",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 2,
      price: 0,
      pricingMode: "RAW",
      volume: 4000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 300,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "a388f51a-11dd-454f-bbdb-fbb4c5488799",
    },
  },
};
const assemblySheetChild5 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:45.397Z",
  id: "3990a4b4-d835-4299-b5f1-94949aadbaeb",
  quantity: 1,
  partId: "4fc49866-ae81-4669-a6fd-3894d19ec752",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  part: {
    createdAt: "2025-12-10T13:53:45.355Z",
    updatedAt: "2025-12-10T13:53:59.986Z",
    id: "4fc49866-ae81-4669-a6fd-3894d19ec752",
    name: "assemblage-tollerie.sh5",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 2,
    width: 117,
    length: 117,
    tubeThickness: null,
    volume: 27335.08,
    area: 28253.91,
    boundingBoxX: 2,
    boundingBoxY: 117,
    boundingBoxZ: 117,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "SHEET",
    quantityInAssembly: 2,
    parentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    rootParentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:45.397Z",
      updatedAt: "2025-12-10T13:54:02.563Z",
      id: "407d2e7b-2868-4a98-8123-bf76588e284c",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 2,
      price: 0,
      pricingMode: "RAW",
      volume: 4000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 128,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "3ea7a357-4632-4a79-acbc-8a5bd8458e52",
    },
  },
};
const assemblySheetChild6 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:47.440Z",
  id: "4b4fbba3-7cd4-46e6-99a5-eeb9f24a90f7",
  quantity: 1,
  partId: "a4d62029-781f-4da9-abdc-c4858e96712a",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  part: {
    createdAt: "2025-12-10T13:53:47.415Z",
    updatedAt: "2025-12-10T13:53:59.986Z",
    id: "a4d62029-781f-4da9-abdc-c4858e96712a",
    name: "assemblage-tollerie.sh7",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 5,
    width: 100,
    length: 100,
    tubeThickness: null,
    volume: 31546.87,
    area: 14333.18,
    boundingBoxX: 5,
    boundingBoxY: 100,
    boundingBoxZ: 100,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "SHEET",
    quantityInAssembly: 4,
    parentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    rootParentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:47.440Z",
      updatedAt: "2025-12-10T13:54:02.645Z",
      id: "841c9159-d40d-4f31-b290-04cf991785b6",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 5,
      price: 0,
      pricingMode: "RAW",
      volume: 10000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 162,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "41719fb0-1eb6-4d91-801b-cc4768eeb3ef",
    },
  },
};
const assemblySheetChild7 = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:40.729Z",
  id: "84d317cb-8977-4ee8-b789-81a33b385188",
  quantity: 1,
  partId: "1ed95356-34fb-47fb-bee2-16445b7f846e",
  assemblyParentId: "1d4121f3-dcc0-45cc-b856-0fec373e74cb",
  part: {
    createdAt: "2025-12-10T13:53:40.711Z",
    updatedAt: "2025-12-10T13:53:59.986Z",
    id: "1ed95356-34fb-47fb-bee2-16445b7f846e",
    name: "assemblage-tollerie.sh2",
    clientReference: null,
    internalReference: null,
    materialGrade: "PLASTIC",
    height: 3,
    width: 300,
    length: 440,
    tubeThickness: null,
    volume: 396362.12,
    area: 266043.06,
    boundingBoxX: 80,
    boundingBoxY: 80,
    boundingBoxZ: 440,
    gltfStatus: "PROCESSED",
    previewStatus: "PROCESSED",
    embeddingStatus: "PROCESSED",
    featuresStatus: "PROCESSED",
    graphStatus: "PROCESSED",
    analyzeStatus: "PROCESSED",
    hasEmbedding: true,
    tolerance: null,
    type: "SHEET",
    quantityInAssembly: 2,
    parentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    rootParentId: "5b653e5e-970d-40b4-a75b-d93f36c16938",
    companyId: "20982d67-2667-4abe-a8ea-5c26c8ba8bdf",
  },
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:40.729Z",
      updatedAt: "2025-12-10T13:54:00.974Z",
      id: "0522c465-0954-4306-af9a-ffcd96a1645d",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 3,
      price: 0,
      pricingMode: "RAW",
      volume: 6000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 12,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "2743420e-9678-41e1-a04c-df19b15ae299",
    },
  },
};

// -----------------------------------------------------------------------------
// Other parts
// -----------------------------------------------------------------------------
const sheet = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.419Z",
  id: "80024938-3827-46c1-9956-a8df4e78ea10",
  quantity: 5,
  partId: "064947dd-9de3-4d0b-a783-9d2b96a35007",
  processSteps: [
    {
      ...emptyMockProcessStep,
      mode: "TIME",
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.419Z",
      updatedAt: "2025-12-10T13:54:10.340Z",
      id: "de24e50d-b15c-4b9f-9e64-728b3afc72cd",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 1.5,
      price: 0,
      pricingMode: "RAW",
      volume: 3000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 25,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "d0728a34-5c2f-473c-b47d-e534b997d4be",
    },
  },
};
const smallPart = {
  ...emptyMockQrl,
  createdAt: "2025-12-10T13:53:28.426Z",
  id: "bff34f97-5b13-44bc-a102-198b4c87f89d",
  quantity: 1,
  partId: "39ec77ca-fd95-4107-921a-b3fb27a9fef8",
  processSteps: [
    {
      ...emptyMockProcessStep,
      industrialProcess: "TURNING",
      description: "TOURNAGE (210100)",
      otherMachineTime: 6,
      machinePreparationTime: 240,
      machineHourlyPrice: 4100,
    },
  ],
  layout: {
    ...emptyMockQrl.layout,
    materialLayout: {
      createdAt: "2025-12-10T13:53:28.426Z",
      updatedAt: "2025-12-10T13:54:00.131Z",
      id: "07ba0305-9c74-494a-82ad-8a57aa0df0ca",
      length: 2000,
      tubeThickness: null,
      width: 1000,
      height: 8,
      price: 0,
      pricingMode: "RAW",
      volume: 16000000,
      volumetricPrice: null,
      density: 1.2,
      quantity: 1,
      maxPartsPerLayout: 3843,
      type: "SHEET",
      materialGrade: "PLASTIC",
      layoutId: "28914b7c-65cd-49ca-9e66-e0f679a87f8e",
    },
  },
};

const quoteRequestLines = [
  simpleSheetBatch1,
  simpleSheetBatch10,

  flatSheetBatch1,
  flatSheetBatch100,
  flatSheetBatch1000,

  assemblySheetParent,
  assemblySheetChild1,
  assemblySheetChild2,
  assemblySheetChild3,
  assemblySheetChild4,
  assemblySheetChild5,
  assemblySheetChild6,
  assemblySheetChild7,

  assemblyParentBatch2,
  assemblyChild1Batch2,
  assemblyChild2Batch2,
  assemblyChild3Batch2,
  assemblyChild4Batch2,
  assemblyChild5Batch2,
  assemblyChild6Batch2,
  assemblyChild7Batch2,

  assemblyParentBatch10,
  assemblyChild1Batch10,
  assemblyChild2Batch10,
  assemblyChild3Batch10,
  assemblyChild4Batch10,
  assemblyChild5Batch10,
  assemblyChild6Batch10,
  assemblyChild7Batch10,

  assemblyParentBatch50,
  assemblyChild1Batch50,
  assemblyChild2Batch50,
  assemblyChild3Batch50,
  assemblyChild4Batch50,
  assemblyChild5Batch50,
  assemblyChild6Batch50,
  assemblyChild7Batch50,

  sheet,
  smallPart,
];

export const mockedQuoteRequestForIntegrationTest = {
  ...mockQuoteRequest,
  quoteRequestLines,
} as unknown as ComputeQuoteRequestPriceParams["quoteRequest"];
